import EmailList from './EmailList';

export default EmailList;
